//@ts-ignore
//@ts-nocheck
import React, { useState, useRef, useEffect } from "react";
import { API } from "aws-amplify";
import FormTitle from "../../FormElements/FormTitle";
import CardInfoCompany from "../../FormElements/CardInfoCompany";
import Title from "../../FormElements/Title";
import { Controller, FormContext, useForm } from "react-hook-form";
import ErrorCustom from "../../errorCustom";
import Button from "../../FormElements/Button";
import CalendarIcon from "../../../Resources/svg/date-picker.svg";
import { useDispatch, useSelector } from "react-redux";
import { Address } from "../../../Pages/wizard/Address";
import { Addressv2 } from "../../../Pages/wizard/AddressV2";
import DateTimePicker from "react-datetime-picker";
import moment from "moment";
import NumberFormat from "react-number-format";
import RadioButtonsResident from "../../../Components/radioButtonsResident";
import {
  validateEmail,
  validatePhone,
  validatePhoneVoid,
  validatorClientText,
  validatorField,
  validateOnlyNumbers,
  validateDocumentByType,
  validateOnlyAlphanumeric,
  validateNumberField,
  validatorDate2,
  validatorFecha,
} from "../../../Utils/validators";
import { formatNumber } from "../../../Utils/utils";
import { typeDocumentListAsInsured as typeDocumentList } from "../../../Utils/constants";

interface Props {
  setLoading: any;
  contractorData: any;
  onSubmit: any;
  nameUbigeo: any;
  setNameUbigeo: any;
  setFormContractorValid: any;
  nameUbigeoContact: any;
  setNameUbigeoContact: any;
  repLegalData: any;
}

const ContractorEntityForm = ({
  setLoading,
  contractorData,
  onSubmit,
  nameUbigeo,
  setNameUbigeo,
  setFormContractorValid,
  nameUbigeoContact,
  setNameUbigeoContact,
  repLegalData
}: Props) => {
  const [errorDate, setErrorDate] = useState<any>(null);
  const methods = useForm({ mode: "onChange" });
  const [maxLengthDocumentNumber, setMaxLengthDocumentNumber] = useState(8);
  const [numDocumento, setnumDocumento] = useState("");
  const [isDataLoaded, setIsDataLoaded] = useState<boolean>(false);
  const {
    handleSubmit,
    register,
    errors,
    watch,
    formState,
    clearError,
    setValue,
    getValues,
    control
  } = methods;
  const { isValid } = formState;
  const inputEl = useRef(null);
  const [stateSalary, setValueSalary] = useState();

  const [repLegalUploaded, setRepLegalUploaded] = useState(false);
  const [nameVia, setNameVia] = useState<any>({
    via: "",
  });


  const [nameViaContact, setNameViaContact] = useState<any>({
    via: "",
  });

  const addCommas = (num: any) =>
    num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const removeNonNumeric = (num: any) => num.toString().replace(/[^0-9]/g, "");

  const handleChange = async (e: any) => {
    const { value } = e.target;
    let validatingDocument = value.toString().length == maxLengthDocumentNumber;
    if (validatingDocument) {
      await getDataClient(value);
    } else {
      setValue("name", "");
      setValue("lastNameFather", "");
      setValue("lastNameMother", "");
      setValue("fecNacimiento", "");
      setValue("sexo", "");
      setValue("civilStatus", "");
      setIsDataLoaded(false);
    }

  };

  const getDataClient = async (value: any) => {
    setLoading(true);
    setnumDocumento(value);
    const typeDoc = getValues().typeDoc;

    if (true) {
      const params = {
        numDocumento: value,
        tipoDocumento: typeDoc,
      };

      await API.post("api-rentas", "/client", {
        body: params,
        headers: {},
      })
        .then((dat) => {
          if (dat.status !== 200) {
            setValue("nroDoc", "");
            setValue("name", "");
            setValue("lastNameFather", "");
            setValue("lastNameMother", "");
            setValue("fecNacimiento", "");
            setValue("sexo", "");
            setValue("civilStatus", "");
            setIsDataLoaded(false);
          } else {
            setValue("name", dat.data.nombres, true);
            setValue("lastNameFather", dat.data.apellidoPaterno, true);
            setValue("lastNameMother", dat.data.apellidoMaterno, true);
            setValue("fecNacimiento", dat.data.fecNacimiento, true);
            setValue("sexo", dat.data.sexo, true);
            dat.data.estadoCivil && setValue("civilStatus", dat.data.estadoCivil, true);
            setIsDataLoaded(true);
          }
        })
        .catch((error: any) => {
          console.log("error.....");
          setIsDataLoaded(false);
        });
    }

    setLoading(false);
  };

  const updateValidationOfdocumentNumber = (value: any) => {
    clearError();
    const validationLength: any = typeDocumentList.find(
      (item) => item.value == value
    );
    setMaxLengthDocumentNumber(validationLength.min);
  };

  const formatDateString = (date: Date) => {
    return new Intl.DateTimeFormat("es-PE", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(date);
  };

  useEffect(() => {
    if(repLegalData){
      setValue("typeDoc", repLegalData.typeDocReplegal, true);
      setValue("nroDoc", repLegalData.nroDocReplegal, true);
      setValue("name", repLegalData.nameReplegal, true);
      setValue("lastNameFather", repLegalData.lastNameFatherReplegal, true);
      setValue("lastNameMother", repLegalData.lastNameMotherReplegal, true);
      setValue("fecNacimiento", repLegalData.fecNacimientoReplegal, true);
      setValue("sexo", repLegalData.sexoReplegal, true);
      setValue("responsability", repLegalData.responsabilityReplegal, true);
      setValue("civilStatus", repLegalData.civilStatusReplegal, true);
      setRepLegalUploaded(true);
    }
  }, [repLegalData]);

  useEffect(() => {
    setFormContractorValid(isValid);
  }, [isValid]);

  return (
    <>
      {contractorData && (
        <> 
          <FormTitle
            title="Ingresa los datos personales del contratante"
            parrafo="El contratante es la persona que es titular de la póliza y es diferente al asegurado."
          />
          <CardInfoCompany client={contractorData} />
          <Title title="Datos del contratante" />
          <FormContext {...methods}>
            <form
              ref={inputEl}
              onSubmit={handleSubmit(onSubmit)}
              className="contractorForm"
            >
              <div className="input clientForm__control input-field">
                <input
                  id="giro"
                  name="giro"
                  maxLength={100}
                  type="text"
                  className={errors["giro"] ? " is-error" : ""}
                  defaultValue={contractorData.giro}
                  ref={register}
                />
                <label
                  htmlFor="giro"
                  className={contractorData.giro ? "active" : "false"}
                >
                  Giro
                </label>
                <ErrorCustom errors={errors} name="Giro" />
              </div>

              <div className="input clientForm__control input-field">
                <input
                  id="email"
                  name="email"
                  maxLength={100}
                  type="text"
                  className={errors["email"] ? " is-error" : ""}
                  defaultValue={contractorData.email}
                  ref={register({ validate: validateEmail })}
                />
                <label
                  htmlFor="email"
                  className={contractorData.email ? "active" : "false"}
                >
                  Correo electrónico
                </label>
                <ErrorCustom errors={errors} name="email" />
              </div>

              <div className="group-form">
                <div className="clientForm__control input-field">
                  <input
                    id="phone"
                    name="phone"
                    className={errors["phone"] ? " is-error" : ""}
                    ref={register({ validate: validatePhone })}
                    maxLength={50}
                    defaultValue={contractorData.cellphone}
                    type="text"
                  />
                  <label
                    htmlFor="phone"
                    className={contractorData.phone ? "active" : "false"}
                  >
                    Teléfono
                  </label>
                  <ErrorCustom errors={errors} name="phone" />
                </div>

                <div className="clientForm__control input-field">
                  <input
                    id="cellphone"
                    name="cellphone"
                    defaultValue={contractorData.phone}
                    maxLength={50}
                    type="text"
                    className={errors["cellphone"] ? " is-error" : ""}
                    ref={register({ validate: validatePhone })}
                  />
                  <label
                    htmlFor="cellphone"
                    className={contractorData.cellphone ? "active" : "false"}
                  >
                    Celular
                  </label>
                  <ErrorCustom errors={errors} name="cellphone" />
                </div>
              </div>

              <Title title="Datos de contacto" />
              <Address
                  nameUbigeo={nameUbigeo}
                  setNameUbigeo={setNameUbigeo}
                  nameVia={nameVia}
                  setNameVia={setNameVia}
                />

              <Title title="Datos del representante legal" />
              <div className="vasForm">
                <div className="vasForm__form__input-container group-input dni">
                  <select
                    className="browser-default"
                    onChange={(value) =>
                      updateValidationOfdocumentNumber(value.target.value)
                    }
                    name="typeDoc"
                    ref={register}
                    disabled={isDataLoaded || repLegalUploaded}
                  >
                    {typeDocumentList &&
                      typeDocumentList.map((el) => {
                        return (
                          <option data-object={el} value={el.value} key={el.value}>
                            {el.name}
                          </option>
                        );
                      })}
                  </select>
                  <div className="content">
                    <input
                      placeholder=" "
                      name="nroDoc"
                      onChange={(e) => handleChange(e)}
                      defaultValue={numDocumento}
                      ref={register({
                        validate: (values) =>
                          validateDocumentByType(values, getValues),
                      })}
                      disabled={repLegalUploaded}
                    />
                    <label
                      htmlFor="nroDoc"
                      className={getValues().nroDoc ? "active" : "false"}
                    >
                      Nro. documento
                    </label>
                  </div>
                </div>
                <ErrorCustom errors={errors} name="nroDoc" />
              </div>
              <div className="clientForm__control input-field">
                <input
                  id="name"
                  name="name"
                  defaultValue={""}
                  maxLength={50}
                  type="text"
                  className={errors["name"] ? " is-error" : ""}
                  ref={register({ validate: validatorClientText })}
                  disabled={isDataLoaded || repLegalUploaded}
                />
                <label
                  htmlFor="name"
                  className={getValues().name ? "active" : "false"}
                >
                  Nombres
                </label>
                <ErrorCustom errors={errors} name="name" />
              </div>
              <div className="group-form input-field">
                <div className="clientForm__control input-field">
                  <input
                    id="lastNameFather"
                    name="lastNameFather"
                    className={errors["lastNameFather"] ? " is-error" : ""}
                    ref={register({ validate: validatorClientText })}
                    maxLength={50}
                    type="text"
                    disabled={isDataLoaded || repLegalUploaded}
                  />
                  <label
                    htmlFor="lastNameFather"
                    className={getValues().lastNameFather ? "active" : "false"}
                  >
                    Apellido paterno
                  </label>
                  <ErrorCustom errors={errors} name="lastNameFather" />
                </div>
                <div className="input clientForm__control input-field">
                  <input
                    id="lastNameMother"
                    name="lastNameMother"
                    maxLength={100}
                    type="text"
                    className={errors["lastNameMother"] ? " is-error" : ""}
                    defaultValue={contractorData.lastNameMother}
                    ref={register}
                    disabled={isDataLoaded || repLegalUploaded}
                  />
                  <label
                    htmlFor="lastNameMother"
                    className={getValues().lastNameMother ? "active" : "false"}
                  >
                    Apellido materno
                  </label>
                  <ErrorCustom errors={errors} name="lastNameMother" />
                </div>
              </div>
              <div className="group-form input-field">
                  <div className={`clientForm__control input-field`}>
                    <input
                    placeholder=" "
                    id="fecNacimiento"
                    name="fecNacimiento"
                    format="##/##/####"
                    ref={register({
                      validate: (value) => validatorFecha(value, setValue),
                    })}
                    className={errors["fecNacimiento"] ? " is-error" : ""}
                    disabled={isDataLoaded || repLegalUploaded}
                  />
                  <label
                    htmlFor="fecNacimiento"
                    className={getValues().fecNacimiento ? "active" : "false"}
                  >
                    Fecha de nacimiento
                  </label>
                  <ErrorCustom errors={errors} name="fecNacimiento" />
                  </div>
                <div className="clientForm__control input-field">
                  <select
                    id="sexo"
                    name="sexo"
                    ref={register({ validate: validatorField })}
                    disabled={isDataLoaded || repLegalUploaded}
                  >
                    <option value={""} disabled selected>
                      Sexo
                    </option>
                    <option value="M">Masculino</option>
                    <option value="F">Femenino</option>
                  </select>
                  <ErrorCustom errors={errors} name="sexo" />
                </div>
              </div>
              <div className="group-form input-field">
                <div className="clientForm__control input-field">
                  <input
                    id="responsability"
                    name="responsability"
                    className={errors["responsability"] ? " is-error" : ""}
                    ref={register({ validate: validatorClientText })}
                    maxLength={50}
                    type="text"
                    disabled={repLegalUploaded}
                  />
                  <label
                    htmlFor="responsability"
                    className={contractorData.responsability ? "active" : "false"}
                  >
                    Cargo
                  </label>
                  <ErrorCustom errors={errors} name="responsability" />
                </div>
                <div className="clientForm__control">
                  <select
                    id="civilStatus"
                    name="civilStatus"
                    ref={register({ validate: validatorField })}
                    disabled={Boolean(watch("civilStatus")) || repLegalUploaded}
                  >
                    <option value={""} disabled selected>
                      Estado civil
                    </option>
                    <option value="S">Soltero</option>
                    <option value="C">Casado</option>
                    <option value="D">Divorciado</option>
                    <option value="V">Viudo</option>
                  </select>
                  <ErrorCustom errors={errors} name="civilStatus" />
                </div>
              </div>

              <Title title="Otros Datos" />
              <p className="textGroup">¿Es ciudadano o residente de EE.UU?</p>
              <div
                className={
                  "clientForm__form__item" +
                  (errors["isAmericanResident"] ? " is-error" : "")
                }
              >
                <p>
                  <label>
                    <input
                      className="with-gap"
                      name="isAmericanResident"
                      ref={register({ validate: validatorField })}
                      id="yes_isAmericanResident"
                      type="radio"
                      value="1"
                    />
                    <span>Sí</span>
                  </label>
                </p>
                <p>
                  <label>
                    <input
                      className="with-gap"
                      name="isAmericanResident"
                      ref={register({ validate: validatorField })}
                      id="no_isAmericanResident"
                      value="0"
                      type="radio"
                    />
                    <span>No</span>
                  </label>
                </p>
                <ErrorCustom errors={errors} name="isAmericanResident" />
              </div>
              <div className="clientForm__control input-field">
              <Controller
                    as={NumberFormat}
                    className={`input ${errors["salary"] ? "is-error" : ""}`}
                    thousandSeparator
                    decimalScale={2}
                    decimalSeparator="."
                    name="salary"
                    control={control}
                    defaultValue={contractorData.salary}
                    maxLength={10}
                    rules={{ required: true, maxLength: 10 }}
                  />
                  <label className={contractorData.salary ? "active" : ""} htmlFor="salary">
                    Sueldo
                  </label>
                  <ErrorCustom errors={errors} name="salary" />
              </div>

              <div className="group-form input-field">
                <div className="clientForm__control input-field">
                  <input
                    id="nationality"
                    name="nationality"
                    className={errors["nationality"] ? " is-error" : ""}
                    ref={register({ validate: validatorClientText })}
                    maxLength={50}
                    type="text"
                  />
                  <label
                    htmlFor="nationality"
                    className={contractorData.nationality ? "active" : "false"}
                  >
                    Nacionalidad
                  </label>
                  <ErrorCustom errors={errors} name="nationality" />
                </div>
                <div className="clientForm__control input-field">
                  <input
                    id="countryOfResidence"
                    name="countryOfResidence"
                    className={errors["countryOfResidence"] ? " is-error" : ""}
                    ref={register({ validate: validatorClientText })}
                    maxLength={50}
                    type="text"
                  />
                  <label
                    htmlFor="countryOfResidence"
                    className={
                      contractorData.countryOfResidence ? "active" : "false"
                    }
                  >
                    País Residencia
                  </label>
                  <ErrorCustom errors={errors} name="countryOfResidence" />
                </div>
              </div>
              <Title title="Datos de contacto" />
              <Addressv2
                  nameUbigeo={nameUbigeoContact}
                  setNameUbigeo={setNameUbigeoContact}
                  nameVia={nameViaContact}
                  setNameVia={setNameViaContact}
                />

              <div className="form-register__border"></div>
              <div className="form-register__buttom form-step">
                <Button type="submit" disabled={!isValid ? true : false}>
                  Continuar
                </Button>
              </div>
            </form>
          </FormContext>
        </>
      )}
    </>
  );
};

export default ContractorEntityForm;
